/* eslint-disable react/jsx-props-no-spreading */
import { type GoogleMapPinProps } from '../LocationListingHelpers';
import DuotoneIcon from '2-core-elements/Icon/DuotoneIcon';

interface ItemPinProps extends GoogleMapPinProps {
    onClick?: () => void;
    isActive?: boolean;
    skin?: '1' | '2';
}


const ItemPin = ({ onClick, isActive = false, style, skin = '1' }: ItemPinProps): JSX. Element => {
    return (
        <button
            type="button"
            className={`item-pin skin-${skin} ${isActive ? 'is-active' : ''}`}
            onClick={onClick}
            style={style}

        >
            <div className="item-pin-loader">
                <div className="item-pin-loader-anim">
                    <div className="item-pin-loader-item" />
                    <div className="item-pin-loader-item" />
                </div>
            </div>
            <DuotoneIcon icon="map" />
        </button>
    );
};

export default ItemPin;
